import { lazy } from 'react';

export default [
    {
        path: '/alpenglowee-2026',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'Alpenglowee2026Layout' */ './layout')),
    },
];
